import { getIsQa } from '../constants/apiEnvironments';
import { EndpointKey } from '../http/EndpointKey';
import { getQueryParams } from '../routing/getQueryParams';
import { getEndpointRetries } from '../store/http-responses/selectors';
export const shouldSimulateRecaptchaFailure = state => {
  const retrySignupEndpoint = getEndpointRetries(state, EndpointKey.Signup);
  const queryParams = getQueryParams();
  const simulateRecaptcha = queryParams['simulateRecaptchaFailure'] === 'true';
  return simulateRecaptcha && retrySignupEndpoint === 0 && getIsQa();
};